// extracted by mini-css-extract-plugin
export var disabled = "_l-a";
export var hierarchyLinkGray = "_l-4";
export var hierarchyLinkUnderline = "_l-3";
export var hierarchyPrimary = "_l-0";
export var hierarchySecondary = "_l-1";
export var hierarchyTertiary = "_l-2";
export var pressed = "_l-6";
export var themeAction = "_l-5";
export var themeDestructive = "_l-8";
export var themeNormal = "_l-7";
export var themeSuccess = "_l-9";